import React, { useContext, useState } from 'react';
import { LanguageContext } from '../App';
import Layout from './Layout';

const Settings = () => {
  const { language, setLanguage, t } = useContext(LanguageContext);
  const [notifications, setNotifications] = useState({
    email: true,
    push: true,
    taskReminders: true,
    dailySummary: false
  });

  const [preferences, setPreferences] = useState({
    defaultPriority: 'medium',
    defaultCategory: 'other',
    weekStartsOn: 'sunday',
    timeFormat: '24h'
  });

  const handleNotificationChange = (key, value) => {
    setNotifications(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handlePreferenceChange = (key, value) => {
    setPreferences(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const exportData = () => {
    // This would typically generate a PDF or CSV export
    alert('سيتم إضافة ميزة التصدير قريباً');
  };

  const importData = () => {
    // This would handle file import
    alert('سيتم إضافة ميزة الاستيراد قريباً');
  };

  return (
    <Layout>
      <div className="fade-in">
        {/* Page Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {t('settings')}
          </h1>
          <p className="text-gray-600">
            تخصيص إعدادات التطبيق حسب احتياجاتك
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Language & Display */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">اللغة والعرض</h3>
              <p className="card-subtitle">إعدادات اللغة وطريقة العرض</p>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">لغة التطبيق</label>
                <select
                  className="form-control form-select"
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  <option value="ar">العربية</option>
                  <option value="en">English</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">تنسيق الوقت</label>
                <select
                  className="form-control form-select"
                  value={preferences.timeFormat}
                  onChange={(e) => handlePreferenceChange('timeFormat', e.target.value)}
                >
                  <option value="24h">24 ساعة</option>
                  <option value="12h">12 ساعة</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">بداية الأسبوع</label>
                <select
                  className="form-control form-select"
                  value={preferences.weekStartsOn}
                  onChange={(e) => handlePreferenceChange('weekStartsOn', e.target.value)}
                >
                  <option value="sunday">الأحد</option>
                  <option value="monday">الاثنين</option>
                  <option value="saturday">السبت</option>
                </select>
              </div>
            </div>
          </div>

          {/* Notifications */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">الإشعارات</h3>
              <p className="card-subtitle">إدارة إشعارات التطبيق</p>
            </div>
            <div className="card-body">
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold">إشعارات البريد الإلكتروني</div>
                    <div className="text-sm text-gray-600">تلقي إشعارات عبر البريد</div>
                  </div>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={notifications.email}
                      onChange={(e) => handleNotificationChange('email', e.target.checked)}
                    />
                    <span className="slider"></span>
                  </label>
                </div>

                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold">الإشعارات الفورية</div>
                    <div className="text-sm text-gray-600">إشعارات فورية في المتصفح</div>
                  </div>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={notifications.push}
                      onChange={(e) => handleNotificationChange('push', e.target.checked)}
                    />
                    <span className="slider"></span>
                  </label>
                </div>

                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold">تذكير بالمهام</div>
                    <div className="text-sm text-gray-600">تذكير قبل موعد استحقاق المهام</div>
                  </div>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={notifications.taskReminders}
                      onChange={(e) => handleNotificationChange('taskReminders', e.target.checked)}
                    />
                    <span className="slider"></span>
                  </label>
                </div>

                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold">ملخص يومي</div>
                    <div className="text-sm text-gray-600">ملخص يومي بالمهام والإنجازات</div>
                  </div>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={notifications.dailySummary}
                      onChange={(e) => handleNotificationChange('dailySummary', e.target.checked)}
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Default Task Settings */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">إعدادات المهام الافتراضية</h3>
              <p className="card-subtitle">القيم الافتراضية للمهام الجديدة</p>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">الأولوية الافتراضية</label>
                <select
                  className="form-control form-select"
                  value={preferences.defaultPriority}
                  onChange={(e) => handlePreferenceChange('defaultPriority', e.target.value)}
                >
                  <option value="high">🔴 عالية</option>
                  <option value="medium">🟡 متوسطة</option>
                  <option value="low">🟢 منخفضة</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">الفئة الافتراضية</label>
                <select
                  className="form-control form-select"
                  value={preferences.defaultCategory}
                  onChange={(e) => handlePreferenceChange('defaultCategory', e.target.value)}
                >
                  <option value="meeting">👥 اجتماع</option>
                  <option value="followup">📞 متابعة</option>
                  <option value="directive">📋 توجيه</option>
                  <option value="email">📧 بريد</option>
                  <option value="note">📝 ملاحظة</option>
                  <option value="other">📌 أخرى</option>
                </select>
              </div>
            </div>
          </div>

          {/* Data Management */}
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">إدارة البيانات</h3>
              <p className="card-subtitle">تصدير واستيراد البيانات</p>
            </div>
            <div className="card-body">
              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold mb-2">تصدير البيانات</h4>
                  <p className="text-sm text-gray-600 mb-3">
                    تصدير جميع مهامك إلى ملف PDF أو Excel
                  </p>
                  <button onClick={exportData} className="btn btn-primary">
                    📄 تصدير البيانات
                  </button>
                </div>

                <div>
                  <h4 className="font-semibold mb-2">استيراد البيانات</h4>
                  <p className="text-sm text-gray-600 mb-3">
                    استيراد المهام من ملف CSV أو Excel
                  </p>
                  <button onClick={importData} className="btn btn-secondary">
                    📥 استيراد البيانات
                  </button>
                </div>

                <div className="border-t pt-4">
                  <h4 className="font-semibold mb-2 text-red-600">منطقة الخطر</h4>
                  <p className="text-sm text-gray-600 mb-3">
                    حذف جميع البيانات نهائياً (لا يمكن التراجع)
                  </p>
                  <button 
                    onClick={() => {
                      if (window.confirm('هل أنت متأكد من حذف جميع البيانات؟ هذا الإجراء لا يمكن التراجع عنه.')) {
                        alert('سيتم إضافة هذه الميزة لاحقاً');
                      }
                    }}
                    className="btn btn-outline text-red-600 border-red-600 hover:bg-red-50"
                  >
                    🗑️ حذف جميع البيانات
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Section */}
        <div className="card mt-6">
          <div className="card-header">
            <h3 className="card-title">الملف الشخصي</h3>
            <p className="card-subtitle">معلومات المستخدم</p>
          </div>
          <div className="card-body">
            <div className="flex items-center gap-6">
              <div className="w-20 h-20 bg-gradient-to-br from-maroon to-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                م.م
              </div>
              <div>
                <h3 className="text-xl font-bold">محمد المشولي</h3>
                <p className="text-gray-600">مدير مكتب تنفيذي</p>
                <p className="text-sm text-gray-500 mt-1">
                  عضو منذ: {new Date().toLocaleDateString('ar-SA')}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Save Button */}
        <div className="mt-6 text-center">
          <button 
            onClick={() => alert('تم حفظ الإعدادات بنجاح!')}
            className="btn btn-primary btn-lg"
          >
            💾 حفظ جميع الإعدادات
          </button>
        </div>
      </div>

      {/* Toggle Switch Styles */}
      <style jsx>{`
        .switch {
          position: relative;
          display: inline-block;
          width: 60px;
          height: 34px;
        }

        .switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }

        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 34px;
        }

        .slider:before {
          position: absolute;
          content: "";
          height: 26px;
          width: 26px;
          left: 4px;
          bottom: 4px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }

        input:checked + .slider {
          background-color: var(--primary-maroon);
        }

        input:checked + .slider:before {
          transform: translateX(26px);
        }
      `}</style>
    </Layout>
  );
};

export default Settings;